import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import getDate from "date-fns/getDate";
import format from "date-fns/format";
import { DATE_FORMAT } from "@config/constants";

export const convertDate = (dateTime) => {
  if (!dateTime) {
    return null;
  }
  const date = new Date(dateTime);
  const year = getYear(date);
  const month = getMonth(date) + 1;
  const day = getDate(date);
  const dayOfWeek = date.toLocaleString("ja-jp", {
    weekday: "short",
  });
  return `${year}年${month}月${day}日(${dayOfWeek})`;
};

export const confirmTimeMstConfig = [
  { id: 100, name: "00:00~01:00" },
  { id: 101, name: "01:00~02:00" },
  { id: 102, name: "02:00~03:00" },
  { id: 103, name: "03:00~04:00" },
  { id: 104, name: "04:00~05:00" },
  { id: 105, name: "05:00~06:00" },
  { id: 106, name: "06:00~07:00" },
  { id: 107, name: "07:00~08:00" },
  { id: 108, name: "08:00~09:00" },
  { id: 109, name: "09:00~10:00" },
  { id: 110, name: "10:00~11:00" },
  { id: 111, name: "11:00~12:00" },
  { id: 112, name: "12:00~13:00" },
  { id: 113, name: "13:00~14:00" },
  { id: 114, name: "14:00~15:00" },
  { id: 115, name: "15:00~16:00" },
  { id: 116, name: "16:00~17:00" },
  { id: 117, name: "17:00~18:00" },
  { id: 118, name: "18:00~19:00" },
  { id: 119, name: "19:00~20:00" },
  { id: 120, name: "20:00~21:00" },
  { id: 121, name: "21:00~22:00" },
  { id: 122, name: "22:00~23:00" },
  { id: 123, name: "23:00~24:00" },
];

// handle image
export const convertImageList = (list) => {
  if (!list?.length) {
    return [];
  }
  return list.map((image, index) => ({ id: index + 1, image: image.data.src }));
};

export const setNewImage = (imageList, image, file) => {
  const listLength = imageList.length;
  return {
    id: listLength ? imageList[0].id + 1 : 1,
    image,
    file,
  };
};
export const convertImageListPayload = (imageList) => {
  return imageList.map((image) => image.image);
};

export const formatPoint = (num) => {
  return Number(num).toLocaleString("en-US");
};

export const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const convertReservationDate = (dates) => {
  return dates.map((date) => {
    return date ? format(date, DATE_FORMAT) : null;
  });
};

export const cleanParams = (params) => {
  const cleaned = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null) {
      cleaned[key] = value;
    }
  });
  return cleaned;
};
